import React, { useEffect } from 'react';
import { useMap } from 'react-leaflet';

interface MapControllerProps {
  bounds: [[number, number], [number, number]];
}

export const MapController: React.FC<MapControllerProps> = ({ bounds }) => {
  const map = useMap();

  useEffect(() => {
    map.fitBounds(bounds);
  }, [map, bounds]);

  return null;
};
